import React, { useState } from 'react'
import Select from '../../../Components/Autocompelte/Select'
import { SkyButton, SkyOutlinedButton } from '../../../Components/Buttons'
import CustomInput from '../../../Components/Input/CustomInput'
import { OFF_CAB_BOOKING, PAID_CAB_BOOKING } from '../../../Services/cabggl'
import { useMutation } from '@apollo/client'
import { toast } from 'react-toastify'
import Swal from 'sweetalert2'
import DateTimePicker from '../../../Components/Input/DateTimePicker'

const OffDuty = ({
  isOpen,
  onClose,
  onAccept,
  onDecline,
  refetch,
  selectedBooking,
}) => {
  const [meterReading, setMeterReading] = useState('')

  const handleInputChange = (text) => {
    setMeterReading(text)
  }

  const [tentativeRelievingDate, setTentativeRelievingDate] = useState(
    new Date(selectedBooking?.tentativeRelievingDate)
  )

  const [updateOffDuty, { loading }] = useMutation(OFF_CAB_BOOKING)
  const [paidCabBooking] = useMutation(PAID_CAB_BOOKING)

  const handleRelievingDateUpdate = async () => {
    if (
      meterReading < selectedBooking?.startingReading ||
      meterReading.startsWith('0')
    ) {
      toast.warn('Enter correct readings')
      return
    }

    const distance = meterReading - selectedBooking?.startingReading

    if (loading) {
      return
    }
    if (distance < 0) {
      toast.warn('Please enter correct reading')
    }
    if (!Number(meterReading) || !Number(distance) || !tentativeRelievingDate) {
      Swal.fire({
        title: 'Error',
        text: 'All fields are mandatory. Please fill in all required details.',
        icon: 'error',
      })
      return
    }

    const confirmation = await Swal.fire({
      title: 'Confirm Meter Reading',
      html: `
        <p><strong>Starting Reading:</strong> ${selectedBooking?.startingReading}</p>
        <p><strong>Ending Reading:</strong> ${meterReading}</p>
        <p><strong>Total Distance:</strong> ${distance} Km</p>
      `,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
    })

    if (!confirmation.isConfirmed) {
      return
    }

    try {
      const { data } = await updateOffDuty({
        variables: {
          createCabBookingInput: {
            id: selectedBooking?.id,
            endingReading: Number(meterReading),
            distance: Number(distance),
            tentativeRelievingDate: tentativeRelievingDate,
            // updatedBy: getDecryptedSessionStorageVariable('conUserId'),
            // updatedName:
            //   getDecryptedSessionStorageVariable('userFirstName') +
            //   ' ' +
            //   getDecryptedSessionStorageVariable('userLastName'),
          },
        },
      })
      if (data) {
        await paidCabBooking({
          variables: {
            createCabBookingInput: {
              id: selectedBooking?.id,
              // updatedBy: getDecryptedSessionStorageVariable('conUserId'),
              // updatedName:
              //   getDecryptedSessionStorageVariable('userFirstName') +
              //   ' ' +
              //   getDecryptedSessionStorageVariable('userLastName'),
            },
          },
        })
          .then((res) => {
            toast.success('Booking Paid successfully')
          })
          .catch((error) => {
            toast.error('Failed to paid booking')
          })
        refetch()
        onClose(false)
      }
    } catch (error) {
      console.log(error)
    }
  }
  return (
    <div>
      <div className="w-full justify-start flex gap-10 flex-col mt-2">
        <div className="w-full text-start max-w-96">
          <div>
            <div className="w-full max-w-md mx-auto">
              <DateTimePicker
                labelValue="Reporting Date And Time:"
                selectedDate={tentativeRelievingDate ?? new Date()}
                onDateChange={(date) => {
                  setTentativeRelievingDate(date)
                }}
              />
            </div>
            <div className="mt-4">
              <label className="text-stone-700 text-xs font-semibold mt-2">
                Enter End meter reading
              </label>
              <CustomInput
                placeholderValue={'0000'}
                value={meterReading}
                onChange={(text) => handleInputChange(text)}
              />
            </div>
          </div>
        </div>
        <div className="flex gap-2">
          <SkyButton
            label={'Off Duty'}
            onClick={() => {
              handleRelievingDateUpdate()
            }}
          />
          <SkyOutlinedButton label={'Cancel'} onClick={() => onClose()} />
        </div>
      </div>
    </div>
  )
}

export default OffDuty
